import ReuseableTable from "components/Tables/ReuseableTable";
import moment from "moment";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { Card, Col, Container, Row, Spinner } from "reactstrap";
import { verifyMomentos } from "store/actions/VerifyBadgesAction";

const VerifyMomento = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [dataLoader, setDataLoader] = useState(true);
  useEffect(() => {
    dispatch(
      verifyMomentos(id, () => {
        setDataLoader(false);
      })
    );
  }, []);
  const { verifyMomento } = useSelector((state) => state.verifyBadges);
  const TABLE_DATA = {
    columns: [
      "Fan Name",
      "Fan Email",
      "Athlete Name",
      "Athlete Email",
      "Purchase Amount",
      "Purchase Date",
    ],
    keyMap: {
      "Fan Name": "fanName",
      "Fan Email": "fanEmail",
      "Athlete Name": "athleteFirstName",
      "Athlete Email": "athleteEmail",
      "Purchase Amount": "dataAmount",
      "Purchase Date": "dataCreatedAtSeconds",
    },
    data: {
      fanName: verifyMomento.fan.name,
      fanEmail: verifyMomento.fan.email,
      athleteFirstName:
        verifyMomento.athlete.first_name +
        " " +
        verifyMomento.athlete.last_name,
      athleteEmail: verifyMomento.athlete.email,
      dataAmount: verifyMomento.data.amount,
      dataCreatedAtSeconds: moment
        .unix(verifyMomento.data.createdAt.seconds)
        .format("D MMM YYYY"),
    },
  };
  return (
    <div>
      <Container className="pt-4">
        <Row className="mt-4">
          <Col md="12">
            <Card className="p-4">
              <h1 className="text-center">This Momento details </h1>
              {dataLoader ? (
                <div className="text-center">
                  <Spinner color="primary" />
                </div>
              ) : Object.keys(verifyMomento).length === 0 ? (
                <p>This Badge not found</p>
              ) : (
                <>
                  <ReuseableTable {...TABLE_DATA} />
                </>
              )}
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default VerifyMomento;
